import { useContext, useMemo } from 'react';

import { Table, Typography } from 'antd';

import { WizardDataFormContext } from '../../../../Wizard/contexts/WizardDataForm';

import { formattedPrice } from '../../../../../../../../../shared/utils';
import { COLORS } from '../../../../../../../../../config/themes/colors';

export const FloatCarsSummary = () => {
  const { coverageSelectedByVehicle } = useContext(WizardDataFormContext);

  const calculateAllPrimaAmount = useMemo(
    () =>
      coverageSelectedByVehicle.reduce(
        (a, b) => a + Number(b.coverageSelected.prima),
        0
      ),
    [coverageSelectedByVehicle]
  );

  const calculateAllPremioAmount = useMemo(
    () =>
      coverageSelectedByVehicle.reduce(
        (a, b) => a + Number(b.coverageSelected.premio),
        0
      ),
    [coverageSelectedByVehicle]
  );

  const calculateAllCommisionAmount = useMemo(
    () =>
      coverageSelectedByVehicle.reduce(
        (a, b) =>
          a + Number(b.coverageSelected.importesCobertura.importeComision),
        0
      ),
    [coverageSelectedByVehicle]
  );

  return (
    <Table.Summary.Row
      style={{
        backgroundColor: COLORS.principal[15],
        color: COLORS.secondary[100],
      }}
    >
      <Table.Summary.Cell index={0} colSpan={3}>
        <Typography.Text strong style={{ color: COLORS.secondary[100] }}>
          Totales
        </Typography.Text>
      </Table.Summary.Cell>
      <Table.Summary.Cell index={3}>
        <Typography.Text strong style={{ color: COLORS.secondary[100] }}>
          {`$${formattedPrice(String(calculateAllPrimaAmount))}`}
        </Typography.Text>
      </Table.Summary.Cell>
      <Table.Summary.Cell index={4}>
        <Typography.Text strong style={{ color: COLORS.secondary[100] }}>
          {`$${formattedPrice(String(calculateAllCommisionAmount))}`}
        </Typography.Text>
      </Table.Summary.Cell>
      <Table.Summary.Cell index={5}>
        <Typography.Text strong style={{ color: COLORS.secondary[100] }}>
          {`$${formattedPrice(String(calculateAllPremioAmount))}`}
        </Typography.Text>
      </Table.Summary.Cell>
    </Table.Summary.Row>
  );
};
